/* eslint-disable no-useless-escape */
// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';

import { Auth } from '@aws-amplify/auth';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import Swal from 'sweetalert2';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// IMPORT PROJECT REFERENCES
import { signUpConfirm } from '../state/actions/SignUpActions';

//import { History } from '../../helpers/History';

// COMPONENT

class SignupConfirmComponent extends Component {
    constructor(props) {
        super(props);

        // reset login status
        //this.props.logout();

        this.state = {
            code: '',
            submitted: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleConfirmErrorMessage = this.handleConfirmErrorMessage.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { code } = this.state;

        const username = this.getUrlParameter('username'); //params = qs.parse(History.location.search);

        if (username && code) {
            this.props.signUpConfirm(username, code, this.handleConfirmErrorMessage).then(() => {
                this.handleConfirmMessage();
            });
        }
    }

    // TODO: use URLSearchParams instead???
    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        const results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    handleConfirmErrorMessage(errorMessage) {
        Swal({
            title: 'Sign up confirm failed',
            text: errorMessage,
            type: 'error',
        });
    }

    handleConfirmMessage() {
        Swal({
            title: 'Sign up confirmed',
            text: 'The confirmation code was accepted.',
            type: 'success',
        });
    }

    handleResendConfirmation(e) {
        e.preventDefault();
        const username = this.getUrlParameter('username'); // params = qs.parse(History.location.search);

        Auth.resendSignUp(username)
            .then(() => {
                Swal({
                    title: 'Confirmation sent',
                    text: 'A confirmation email was sent to your account.',
                    type: 'success',
                });
            })
            .catch(err => {
                Swal({
                    title: 'Oops...',
                    text: err.message,
                    type: 'error',
                });
            });
    }

    render() {
        const loginFormStyle = {
            padding: '25px',
        };

        const { signUpConfirming, userConfirmed } = this.props;
        const { code, submitted } = this.state;

        console.log('params', this.getUrlParameter('username')); //  qs.parse(History.location.search));

        if (userConfirmed) {
            return <Redirect to="/" />;
        } else {
            return (
                <div className="row h-100 align-items-center justify-content-center">
                    <div style={loginFormStyle} className="card col-6 my-auto">
                        <div className="col-12">
                            <h2 className="text-center">Confirm Your Signup</h2>
                            <h4 className="text-center">
                                We&apos;ve sent an email with your confirmation code.
                            </h4>
                            <form name="form" onSubmit={this.handleSubmit}>
                                <div
                                    className={
                                        'form-group' + (submitted && !code ? ' has-error' : '')
                                    }
                                >
                                    <label htmlFor="code">Confirmation Code</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="code"
                                        value={code}
                                        onChange={this.handleChange}
                                    />
                                    {submitted && !code && (
                                        <div className="help-block">
                                            Confirmation code is required
                                        </div>
                                    )}
                                </div>
                                <div className="form-group text-center">
                                    <button className="btn btn-primary" disabled={signUpConfirming}>
                                        Confirm My Account
                                    </button>
                                    {signUpConfirming && (
                                        <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                    )}
                                </div>
                                <div className="form-group text-center">
                                    <a onClick={this.handleResendConfirmation} href="#">
                                        Re-send confirmation email
                                    </a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

SignupConfirmComponent.propTypes = {
    signUpConfirm: PropTypes.func.isRequired,
    //federatedSignup: PropTypes.func.isRequired,
    signUpConfirming: PropTypes.bool.isRequired,
    userConfirmed: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
    console.log('state', state);
    const { signUpConfirming, userConfirmed } = state.signUp;

    return { signUpConfirming, userConfirmed };
}

const mapDispatchToProps = dispatch => bindActionCreators({ signUpConfirm }, dispatch);

const hoc = connect(mapStateToProps, mapDispatchToProps)(SignupConfirmComponent);
export { hoc as SignupConfirmComponent };
